module.exports = __webpack_public_path__ + "img/original-sketch-2.7cb5d939.png";